<div class="container">
	<div class="sidenav">
		<nav class="sidebar" id="sidebar">
			<ul>
				<li>
					<button mat-button [routerLink]="['/']" routerLinkActive="active" (click)="toggleSidebar()"
						[routerLinkActiveOptions]="{exact: true}" class="sidebar-image-button">
						<mat-icon>home</mat-icon>
						<span class="sidebar-text">HOME</span>
					</button>
				</li>
				<h5>INIZIATIVE DE CIFRIS</h5>
				<li>
					<button mat-button [routerLink]="['/attivita']" routerLinkActive="active" (click)="toggleSidebar()"
						[routerLinkActiveOptions]="{exact: true}" class="sidebar-image-button">
						<mat-icon>public</mat-icon>
						<span class="sidebar-text">Attività</span>
					</button>
				</li>
				<li>
					<button mat-button [routerLink]="['/attivita/eventi']" routerLinkActive="active"
						(click)="toggleSidebar()" [routerLinkActiveOptions]="{exact: true}"
						class="sidebar-image-button">
						<mat-icon>event_upcoming</mat-icon>
						<span class="sidebar-text">Eventi</span>
					</button>
				</li>
				<li>
					<button mat-button [routerLink]="['/attivita/corsi']" routerLinkActive="active"
						(click)="toggleSidebar()" [routerLinkActiveOptions]="{exact: true}"
						class="sidebar-image-button">
						<mat-icon>history_edu</mat-icon>
						<span class="sidebar-text">Corsi</span>
					</button>
				</li>
				<li>
					<button mat-button [routerLink]="['/attivita/seminari']" routerLinkActive="active"
						(click)="toggleSidebar()" [routerLinkActiveOptions]="{exact: true}"
						class="sidebar-image-button">
						<mat-icon>person_raised_hand</mat-icon>
						<span class="sidebar-text">Seminari</span>
					</button>
				</li>
				<li>
					<button mat-button [routerLink]="['/attivita/editoria']" routerLinkActive="active"
						(click)="toggleSidebar()" [routerLinkActiveOptions]="{exact: true}"
						class="sidebar-image-button">
						<mat-icon>menu_book</mat-icon>
						<span class="sidebar-text">Editoria</span>
					</button>
				</li>
				<li>
					<button mat-button [routerLink]="['/attivita/gare-crittografiche']" routerLinkActive="active"
						(click)="toggleSidebar()" [routerLinkActiveOptions]="{exact: true}"
						class="sidebar-image-button">
						<mat-icon>emoji_events</mat-icon>
						<span class="sidebar-text">Gare crittografiche</span>
					</button>
				</li>
				<li>
					<button mat-button [routerLink]="['/attivita/iniziative-divulgative']" routerLinkActive="active"
						(click)="toggleSidebar()" [routerLinkActiveOptions]="{exact: true}"
						class="sidebar-image-button">
						<mat-icon>campaign</mat-icon>
						<span class="sidebar-text">Divulgazione</span>
					</button>
				</li>
			</ul>
		</nav>
	</div>
	<div class="content" (click)="toggleSidebar(true)">
		<div style="text-align: center;padding:0; margin-bottom: 10px;">
			<p style="color:var(--cifris_blue);font-size: larger; font-weight: bold;margin:0; display: inline;">
				Attività ed iniziative </p>
		</div>
		<router-outlet></router-outlet>
	</div>
	<ul class="bottomnav-menu">
		<li>
			<button mat-button [routerLink]="['/']" routerLinkActive="active" 
				[routerLinkActiveOptions]="{exact: true}">
				<mat-icon style="color:var(--cifris_azure_transparent);">home</mat-icon>
				<span style="color:var(--cifris_azure_transparent);">HOME</span>
			</button>
		</li>
		<li>
			<button mat-button [routerLink]="['/attivita']" routerLinkActive="active"
				[routerLinkActiveOptions]="{exact: true}">
				<mat-icon style="color:var(--cifris_azure_transparent);">public</mat-icon>
				<span style="color:var(--cifris_azure_transparent);">Attività</span>
			</button>
		</li>
		<li>
			<button mat-button [routerLink]="['/attivita/eventi']" routerLinkActive="active" 
				[routerLinkActiveOptions]="{exact: true}">
				<mat-icon>event_upcoming</mat-icon>
				<span>Eventi</span>
			</button>
		</li>
		<li>
			<button mat-button [routerLink]="['/attivita/corsi']" routerLinkActive="active" 
				[routerLinkActiveOptions]="{exact: true}">
				<mat-icon>history_edu</mat-icon>
				<span>Corsi</span>
			</button>
		</li>
		<li>
			<button mat-button [routerLink]="['/attivita/seminari']" routerLinkActive="active" 
				[routerLinkActiveOptions]="{exact: true}">
				<mat-icon>person_raised_hand</mat-icon>
				<span>Seminari</span>
			</button>
		</li>
		<li>
			<button mat-button [routerLink]="['/attivita/editoria']" routerLinkActive="active" 
				[routerLinkActiveOptions]="{exact: true}">
				<mat-icon>menu_book</mat-icon>
				<span>Editoria</span>
			</button>
		</li>
		<li>
			<button mat-button [routerLink]="['/attivita/gare-crittografiche']" routerLinkActive="active"
				[routerLinkActiveOptions]="{exact: true}">
				<mat-icon>emoji_events</mat-icon>
				<span>Gare crittografiche</span>
			</button>
		</li>
		<li>
			<button mat-button [routerLink]="['/attivita/iniziative-divulgative']" routerLinkActive="active"
				[routerLinkActiveOptions]="{exact: true}">
				<mat-icon>campaign</mat-icon>
				<span>Divulgazione</span>
			</button>
		</li>
	</ul>
</div>